export default function DashboardContactUs() {
  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-white mb-10'>
      <p className='font-bold text-xl mb-4'>Contact Info:</p>
      <p className='font-bold text-gray-500 mb-4'>Email: <a href='mailto:contact@setcpros.com' className='font-normal text-blue-800 underline'>contact@setcpros.com</a></p>
      <p className='font-bold text-gray-500 mb-4'>Phone: <span className='font-normal text-black'>(833) 738-2776</span></p>
      <p className='font-bold text-gray-500 mb-4'>Customer Support Hours: 
        <div className='font-normal text-black'>
          <p>Monday - Friday</p>
          <p>9:00am EST - 5:00pm EST</p>
        </div>
      </p>
      <p className='font-bold text-gray-500 mb-4'>Office Location: 
        <div className='font-normal text-black'>
          <p>1717 Pennsylvania Avenue NW </p>
          <p>10th Floor</p>
          <p>Washington, D.C. 20006</p>
        </div>
      </p>
    </div>
  )
}